import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagZW = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M47.607 14.316a25.064 25.064 0 0 0-5.097-7.159L25 5.434 7.49 7.158c-.056.054-.11.11-.166.166l6.993 6.992L25 14.642l22.607-.326ZM7.324 42.674c.092.092.184.184.277.274L25 44.563l17.398-1.615a25.066 25.066 0 0 0 5.158-7.158l-32.339-1.01-7.893 7.894Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "m49.751 21.476-29.099-.823L25 25.001l-4.348 4.348 29.084-.714a25.181 25.181 0 0 0 .015-7.159Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25 0C18.18 0 12 2.731 7.49 7.158h35.02A24.917 24.917 0 0 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M21.475 21.476h28.276a24.823 24.823 0 0 0-2.144-7.158h-33.29l7.158 7.158ZM14.208 35.792h33.349a24.827 24.827 0 0 0 2.18-7.158h-28.37l-7.159 7.158Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25 50.001a24.915 24.915 0 0 0 17.398-7.05H7.602A24.915 24.915 0 0 0 25 50.001Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M8.927 5.854c-.556.467-1.092.956-1.605 1.47L25 25 7.322 42.679a25.14 25.14 0 0 0 1.605 1.469l19.147-19.147L8.927 5.854Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m10.051 18.479 1.619 4.982h5.239l-4.238 3.08 1.618 4.981-4.238-3.079-4.238 3.08 1.619-4.983-4.238-3.08h5.239l1.618-4.981Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m14.504 25.408-4.219-1.494s-.312-2.924-.33-3.023a1.631 1.631 0 1 0-3.173.736l-1.183 1.19h2.103c0 2.184-1.629 2.184-1.629 4.358l.904 2.174h5.434l.906-2.174c.09-.209.146-.424.168-.639.781-.316 1.019-1.128 1.019-1.128Z"
}));
FlagZW.displayName = 'FlagZW';
export default withFlagWrapper(FlagZW);
//# sourceMappingURL=index.js.map